import { api } from "../_services";
import { modalAlert, getDisciplinesList } from "../_actions";

export function getDisciplines(token) {
  return dispatch => {
    const url = "/api/v1/disciplines/";
    return api.getFetch(url, "", token).then(json => {
      if (json.ok === false) {
        //if fetch error, error modal pop up.
        json.errorMsg = "Unable to get the disciplines.";
        dispatch(modalAlert(json));
      } else {
        dispatch(getDisciplinesList(json.results));
        return json;
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/_services/disciplines.service.js